import { TrendLabel } from '@/components/customComponents'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { formatNumber } from '@/utils'

interface MiniMetricCardProps {
  title: string
  content?: string | number
  type: 'money' | 'percentage' | 'number'
  className?: string
  leftValue?: string | number
  rightValue?: string | number
}

export default function MiniMetricCard({
  title,
  type,
  className = '',
  leftValue,
  rightValue,
}: MiniMetricCardProps) {
  // TODO: make only one function for all the formatValue functions
  const formatValue = (
    value: string | number | undefined,
    valueType: 'money' | 'percentage' | 'number' | 'hour'
  ) => {
    if (value === undefined) return '-'

    switch (valueType) {
      case 'hour':
        return (
          <span>
            {formatNumber(value, valueType, false)}
            <span className="text-sm">hr</span>
          </span>
        )
      case 'number':
      case 'money':
      case 'percentage':
        return formatNumber(value, valueType)
      default:
        return value
    }
  }

  return (
    <Card className={`${className} hover:shadow-md transition-shadow`}>
      <CardHeader className="p-3 pb-0">
        <CardTitle className="text-sm text-muted-foreground">{title}</CardTitle>
      </CardHeader>
      <CardContent className="p-3 pt-0">
        <div className="flex items-start justify-between mt-2">
          <div className="flex flex-col">
            {/* <span className="text-xs text-muted-foreground">{leftLabel}</span> */}
            <div className="flex items-center mt-1">
              <span className="text-sm font-medium">
                {formatValue(leftValue, type)}
              </span>
            </div>
          </div>
          <div className="flex flex-col">
            {/* <span className="text-xs text-muted-foreground">{rightLabel}</span> */}
            {leftValue && (
              <div className="flex items-center mt-1">
                <TrendLabel
                  oldValue={rightValue}
                  newValue={leftValue}
                  isNormal={true}
                  trendType={type}
                />
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
